import { createSlice } from "@reduxjs/toolkit";
import { getAppSessionsThunk, logoutUserThunk } from "./AppSession.thunk";

const initialState = {
  appSessionData: [],
  loading: false,
  status: "",
  message: "",
  logoutData: [],
};

const appSessionSlice = createSlice({
  name: "app_session",
  initialState,
  reducers: {},
  extraReducers: {
    [getAppSessionsThunk.pending]: (state, action) => {
      state.loading = true;
      state.appSessionData = [];
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getAppSessionsThunk.fulfilled]: (state, action) => {
      state.loading = false;
      state.appSessionData = action.payload;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getAppSessionsThunk.rejected]: (state, action) => {
      state.loading = false;
      state.appSessionData = [];
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [logoutUserThunk.pending]: (state, action) => {
      state.loading = true;
      state.logoutData = [];
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [logoutUserThunk.fulfilled]: (state, action) => {
      state.loading = false;
      state.logoutData = action.payload;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [logoutUserThunk.rejected]: (state, action) => {
      state.loading = false;
      state.logoutData = [];
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export default appSessionSlice.reducer;
